document.addEventListener("DOMContentLoaded", () => {
  // Fix crossfade: elimina transform incorrecto si lo hay
  function fixCrossfadeSlides(context = document) {
    const sliders = context.querySelectorAll(".w-slider[data-animation='cross']");
    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll(".w-slide");
      slides.forEach((slide) => {
        if (slide.style.transform && slide.style.transform.includes("translateX")) {
          slide.style.transform = "none";
        }
      });
    });
  }

  // Activa contador de slides para sliders visibles
  function activateSlideCounters() {
    const sliders = document.querySelectorAll(".w-slider[data-animation='cross']");

    sliders.forEach((slider) => {
      if (slider.offsetParent === null) return; // ignorar si está oculto

      const sliderMask = slider.querySelector(".w-slider-mask");
      const navWrapper = slider.querySelector(".w-slider-nav");

      if (!sliderMask || !navWrapper) return;

      const slides = Array.from(sliderMask.children).filter((slide) =>
        slide.classList.contains("w-slide")
      );
      const totalSlides = slides.length;
      if (totalSlides === 0) return;

      let counter = navWrapper.querySelector(".slider-counter");
      if (!counter) {
        counter = document.createElement("div");
        counter.classList.add("slider-counter");
        navWrapper.appendChild(counter);
      }

      function updateCounter() {
        const activeIndex = slides.findIndex((slide) =>
          slide.classList.contains("w-active")
        );
        const indexToShow = activeIndex >= 0 ? activeIndex + 1 : 1;
        counter.textContent = `${String(indexToShow).padStart(2, "0")} / ${String(totalSlides).padStart(2, "0")}`;
      }

      const observer = new MutationObserver(() => setTimeout(updateCounter, 100));
      observer.observe(sliderMask, { attributes: true, childList: true, subtree: true });

      slider.querySelectorAll(".w-slider-dot, .w-slider-arrow-left, .w-slider-arrow-right").forEach((el) => {
        el.addEventListener("click", () => setTimeout(updateCounter, 300));
      });

      setTimeout(updateCounter, 500);
    });
  }

  // --- TABS PERSONALIZADOS + FIX DE SLIDER ---
  const tabs = document.querySelectorAll(".brand-tabs-menu .w-tab-link");
  const panes = document.querySelectorAll(".brand-tabs-content .w-tab-pane");

  if (tabs.length && panes.length) {
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();

        tabs.forEach((t) => t.classList.remove("w--current"));
        panes.forEach((p) => p.classList.remove("w--tab-active"));

        tab.classList.add("w--current");
        panes[index].classList.add("w--tab-active");

        const pane = panes[index];
        const slider = pane.querySelector(".w-slider[data-animation='cross']");

        if (slider) {
          const clone = slider.cloneNode(true);
          const parent = slider.parentElement;
          slider.remove();
          parent.appendChild(clone);

          setTimeout(() => {
            if (window.Webflow && Webflow.require) {
              Webflow.require("slider").ready();
            }
            fixCrossfadeSlides(pane);
            activateSlideCounters();
          }, 100);
        }
      });
    });
  }

  // --- INIT CROSSFADE EN SLIDER VISIBLE DESDE CARGA ---
  setTimeout(() => {
    fixCrossfadeSlides();
    activateSlideCounters();
  }, 1000);

  // --- COLOR DINÁMICO DE FOOTER (opcional) ---
  const footer = document.querySelector(".footer");
  const main = document.querySelector(".main");

  if (footer && main) {
    const shopifySections = main.querySelectorAll(".shopify-section");
    if (shopifySections.length > 0) {
      const lastSection = shopifySections[shopifySections.length - 1].querySelector(".section");
      if (lastSection) {
        footer.style.backgroundColor = window.getComputedStyle(lastSection).backgroundColor;
      }
    }
  }
});